import { X } from "lucide-react";
import CustomInput from "../../../shared/CustomInput";
import Loading from "../../../shared/Loading";

const EditKin = ({
  closeEditKinDetails,
  kinEditDetails,
  setKinEditDetails,
  handleEditNextOfKinDetails,
  loadingUpdateKin,
}) => {
  return (
    <div
      onClick={() => closeEditKinDetails()}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[880px] h-[550px] rounded-[10px] p-[20px] relative bg-white overflow-y-auto"
      >
        <div
          onClick={closeEditKinDetails}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <p className="font-semibold text-[#000000] text-[16px]">
          Edit Next of Kin Details
        </p>
        <p className="text-[15px] font-medium text-[#5C5C5C] mb-[20px]">
          Please fill in the next of kin information below to help us better
          understand your profile and serve you more effectively. All fields are
          required unless marked optional.
        </p>

        <div className="flex flex-col gap-4">
          {/* Row 1: Full Name & Phone Number */}
          <div className="flex justify-between gap-4">
            <div className="w-[49%] flex flex-col">
              <label className="text-[#222222] font-medium text-[13px]">
                Full Name
              </label>
              <CustomInput
                placeholder="Enter full name"
                type="text"
                value={kinEditDetails.name}
                onChange={(e) =>
                  setKinEditDetails({ ...kinEditDetails, name: e.target.value })
                }
              />
            </div>

            <div className="w-[49%] flex flex-col">
              <label className="text-[#222222] font-medium text-[13px]">
                Phone Number
              </label>
              <CustomInput
                placeholder="Enter phone number"
                type="text"
                value={kinEditDetails.phoneNumber}
                onChange={(e) =>
                  setKinEditDetails({
                    ...kinEditDetails,
                    phoneNumber: e.target.value,
                  })
                }
              />
            </div>
          </div>

          {/* Row 2: Relationship & Location */}
          <div className="flex justify-between gap-4">
            <div className="w-[49%] flex flex-col">
              <label className="text-[#222222] font-medium text-[13px]">
                Relationship
              </label>
              <CustomInput
                placeholder="Enter relationship"
                type="text"
                value={kinEditDetails.relationship}
                onChange={(e) =>
                  setKinEditDetails({
                    ...kinEditDetails,
                    relationship: e.target.value,
                  })
                }
              />
            </div>

            <div className="w-[49%] flex flex-col">
              <label className="text-[#222222] font-medium text-[13px]">
                Location
              </label>
              <CustomInput
                placeholder="Enter location"
                type="text"
                value={kinEditDetails.location}
                onChange={(e) =>
                  setKinEditDetails({
                    ...kinEditDetails,
                    location: e.target.value,
                  })
                }
              />
            </div>
          </div>

          {/* Row 3: Date of Birth */}
          <div className="flex justify-between gap-4">
            <div className="w-[49%] flex flex-col">
              <label className="text-[#222222] font-medium text-[13px]">
                Date of Birth
              </label>
              <CustomInput
                placeholder="Select date of birth"
                type="date"
                value={
                  kinEditDetails.dateOfBirth
                    ? kinEditDetails.dateOfBirth.replace(/\//g, "-")
                    : ""
                }
                onChange={(e) =>
                  setKinEditDetails({
                    ...kinEditDetails,
                    dateOfBirth: e.target.value,
                  })
                }
              />
            </div>
          </div>
        </div>

        <div className="absolute bottom-[20px] right-[20px] flex items-center justify-center gap-[10px]">
          <button
            onClick={closeEditKinDetails}
            className="h-[35px] bg-[#F3F3F3] rounded-[30px] px-[15px] text-[#5C5C5C] font-medium"
          >
            Close
          </button>
          <button
            disabled={loadingUpdateKin}
            onClick={handleEditNextOfKinDetails}
            className="h-[35px] bg-[#000000] flex items-center justify-center gap-[5px] rounded-[30px] px-[15px] text-[#FFFFFF] font-medium"
          >
            {loadingUpdateKin && <Loading />}
            Edit and Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditKin;
